import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';
import { I18n } from '../../../../components';
// Utils
import { isEmptyValue } from '../../../../utils/common';
// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const PriceContent = ({ children, isMobile = false, unit }) => {
  const [currency, period] = unit?.split('/') || [];

  if (isEmptyValue(children) || !currency || !period) {
    return null;
  }

  return (
    <span>
      <Text size={isMobile ? 'size6-r' : 'size1-m'}>
        {`${children} ${currency}`}
      </Text>
      <Text size={isMobile ? 'size6-r' : 'size5-r-s'} color="grey60">{`/${period}`}</Text>
    </span>
  );
};

PriceContent.propTypes = {
  children: PropTypes.string,
  isMobile: PropTypes.bool,
  unit: PropTypes.string,
};

const Price = ({ children, unit }) => {
  if (isEmptyValue(children)) {
    return null;
  }

  return (
    <div className={cn('container')}>
      <span className={cn('mobile')}>
        <Text size="size6-r">
          <I18n path="common.priceLabel" />
        </Text>
        <PriceContent isMobile unit={unit}>{children}</PriceContent>
      </span>

      <span className={cn('tablet')}>
        <PriceContent unit={unit}>{children}</PriceContent>
      </span>
    </div>
  );
};

Price.propTypes = {
  children: PropTypes.string,
  unit: PropTypes.string,
};

export { Price, PriceContent };
